import React from "react"
import "./ads.css"
import "../../../style/modal.css";

class Modal extends React.Component
{
    constructor(props) {
        super(props);
        this.state = {
            file: null,
            version: props.version,
            imagePreviewURL: props.imagePreviewURL};

    }

    componentWillReceiveProps(nextProps) {
        this.setState({...this.state, imagePreviewURL: nextProps.imagePreviewURL})
    }

    handleSubmit(e) {
        this.props.onChangeValue(this.state.file, this.state.imagePreviewURL)

    }

    onClose = e => {
        this.props.onClose && this.props.onClose(e);
    };

    handleImageChange(e) {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
            this.setState({...this.state, file: file, imagePreviewURL: reader.result});
        };

        reader.readAsDataURL(file);
    }

    render() {
        let imagePreviewUrl = this.state.imagePreviewURL;
        let $imagePreview = null;
        if (imagePreviewUrl) {
            $imagePreview = (<img src={imagePreviewUrl}
            className="img-thumbnail mt-2"
            height={200}
            width={200}
            alt="Preview"                      
            />)
        } else {
            $imagePreview = (
                    <div className="previewText">Please select an Image for Preview</div>
            );

        }

        let modalId = "modal" + this.props.version;

        return (<div className="modal" id={modalId}>
                    <div className="modal-content">
                        <div className="modal-image-box">
                            {$imagePreview}
                         </div>
                        <form>
                            <input className="fileInput"
                                type="file"
                                onChange={(e)=>this.handleImageChange(e)} />
                         </form>
                    <div className="actions">
                        <button onClick={this.onClose.bind(this)} > Close </button>
                        <button className="submitButton"
                            type="submit"
                            onClick={(e)=>this.handleSubmit(e)}>Save
                        </button>
                    </div>
                </div>
        </div>)

    }

}

export default Modal;